import {useEffect, useReducer, useState} from "react";
import {initialState, reducer} from "../../../components/bases/slot/reducer";
import {useSlotsApi} from "../../api/slots";
import {useOrdersApi} from "../../api/orders";
import {useDefaultEndpoints} from "../../api/useDefaultEndpoints";
import {toast} from "react-toastify";
import {textModal} from "../../../components/bases/transfer/textModal";
import {calculateSlotStatus, sortSlotsByStatus} from "../../../components/bases/transfer/calculateSlotStatus";
import {t} from "i18next";

export const useTransferSlot = (slot_url) => {
    const [state, dispatch] = useReducer(reducer, initialState());
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [destinationProductId, setDestinationProductId] = useState(null);
    const [textBtn, setTextBtn] = useState('');
    const [currentSlotStatus, setCurrentSlotStatus] = useState('');
    const [isModalOpen, setModalOpen] = useState(false);

    const {findByUrl} = useSlotsApi();
    const {moveMany} = useOrdersApi();
    const {findAndCountEntries: findSlots} = useDefaultEndpoints('slots');

    const toggleModal = () => setModalOpen(value => !value);

    const findSlotsWithSorting = async (params) => {
        const result = await findSlots(params);
        if (result?.data) {
            const sortedData = sortSlotsByStatus(result.data, selectedRows);
            return {
                ...result,
                data: sortedData
            };
        }
        return result;
    };

    const calculateTotalPaidForLength = () => {
        return selectedRows.reduce((total, row) => total + (row.paid_for_length || 0), 0);
    }

    const getSlotStatus = (slot) => {
        return calculateSlotStatus(slot, selectedRows);
    }

    const handleConfirmTransfer = () => {
        return moveMany(
            selectedRows,
            state.id,
            destinationProductId,
        )
            .then(() => setDestinationProductId(() => undefined))
            .then(() => toast.success(t('common.forms.movePaymentModal.successUpdate')))
            .then(() => {
                window.location.reload();
                toggleModal()
            })
            .catch(() => {
                toast.error(t('common.forms.movePaymentModal.errorUpdate'))
                toggleModal()
            })
    };

    const openTransferModal = (slot) => {
        const slotStatus = getSlotStatus(slot);
        setCurrentSlotStatus(slotStatus.status);
        const modalText = textModal(slot, selectedRows, slotStatus, calculateTotalPaidForLength)
        setTextBtn(modalText);
        setDestinationProductId(slot.id);
        toggleModal();
    };

    const handleSelect = (ids, items) => {
        setSelectedIds(ids);
        setSelectedRows(items);
    };

    useEffect(() => {
        findByUrl(slot_url).then(res => dispatch({type: 'setSlotData', payload: {...res, reload: false}}));
    }, [slot_url]);

    return {
        state,
        selectedRows,
        currentSlotStatus,
        textBtn,
        isModalOpen,
        toggleModal,
        handleConfirmTransfer,
        openTransferModal,
        findSlotsWithSorting,
        calculateTotalPaidForLength,
        getSlotStatus,
        handleSelect
    };
};
